<template>
  <div class="editor" style="margin: 0 15px">
    <div id="editorElem" />
  </div>
</template>

<script>
import E from 'wangeditor'

export default {
  name: 'Editor',

  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editor: null,
      info: null
    }
  },

  watch: {
    value(val, oldVal) {
      // const { txt } = this.editor
      //   if (val !== txt.html()) {
      if (val !== oldVal) {
        this.editor.txt.clear()
        this.info = null
        this.editor.txt.html(val)
      }
    }
  },

  mounted() {
    this.seteditor()
    this.editor.txt.html(this.value)
  },

  created() {},

  methods: {
    seteditor() {
      const _this = this
      _this.editor = new E('#editorElem')
      _this.editor.customConfig.menus = [
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'emoticon', // 表情
        'table', // 表格
        'code', // 插入代码
        'undo', // 撤销
        'redo' // 重复
      ]
      _this.editor.customConfig.fontNames = [
        'Helvetica Neue',
        'Helvetica,Arial',
        'sans-serif',
        '微软雅黑',
        'Arial',
        '宋体',
        'Tahoma',
        'Verdana'
      ]

      _this.editor.customConfig.onchange = (html) => {
        _this.info = html
        _this.$emit('changeInfo', _this.info)
      }
      _this.editor.create()
    }
  }
}
</script>

<style>
#editorElem .w-e-text-container .w-e-text {
  padding: 25px;
}
.w-e-menu {
  z-index: 2 !important;
}
.w-e-text-container {
  z-index: 1 !important;
}
</style>
